import { render, staticRenderFns } from "./RewardDetail.vue?vue&type=template&id=149640e4&scoped=true&lang=pug&"
import script from "./RewardDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./RewardDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RewardDetail.vue?vue&type=style&index=0&id=149640e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149640e4",
  null
  
)

export default component.exports